import { Component } from "@angular/core";
import * as Sentry from "@sentry/angular";
import { OAuthService } from "angular-oauth2-oidc";

@Component({
	standalone: true,
	template: `
    <div class="login-container">
      <div class="login-card">
        <div class="brand-header">
           <span class="partikel-logo">PARTIKEL<b>ART</b></span>
           <div class="divider"></div>
           <span class="client-name">case</span>
        </div>

        <h1>CASE Portal</h1>
        <p>Technical Cleanliness Monitoring</p>
        
        <button (click)="login()" class="login-btn">
          Sign In to Portal
        </button>
        
        <div class="footer-note">
          Powered by PartikelART Analysis Technology
        </div>
      </div>
    </div>
  `,
	styles: [
		`
    :host {
      --brand-purple: #4f3a9c;
      --brand-purple-dark: #3e2c7d;
      --text-dark: #1a1a1a;
      --text-muted: #64748b;
      --bg-light: #f8fafc;
      --border-color: #e2e8f0;
    }

    .login-container {
      display: flex;
      align-items: center;
      justify-content: center;
      min-height: 100vh;
      background-color: var(--bg-light);
      background: radial-gradient(circle at center, #ffffff 0%, #f1f5f9 100%);
      font-family: 'Inter', -apple-system, sans-serif;
    }

    .login-card {
      background: white;
      padding: 56px;
      border-radius: 4px;
      box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.05), 
                  0 0 1px 1px rgba(0, 0, 0, 0.02);
      text-align: center;
      max-width: 420px;
      width: 100%;
    }

    .brand-header {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 12px;
      margin-bottom: 40px;
    }

    .partikel-logo {
      font-size: 14px;
      letter-spacing: 2px;
      color: var(--text-dark);
    }

    .divider {
      height: 20px;
      width: 1px;
      background: var(--border-color);
    }

    .client-name {
      font-weight: 700;
      letter-spacing: 1px;
      color: var(--brand-purple);
      font-size: 14px;
      text-transform: lowercase;
    }

    h1 {
      margin: 0 0 8px 0;
      font-size: 28px;
      font-weight: 600;
      color: var(--text-dark);
      letter-spacing: -0.5px;
    }

    p {
      margin: 0 0 40px 0;
      color: var(--text-muted);
      font-size: 16px;
    }

    .login-btn {
      width: 100%;
      padding: 16px 24px;
      font-size: 15px;
      font-weight: 600;
      background: var(--brand-purple);
      color: white;
      border: none;
      border-radius: 4px;
      cursor: pointer;
      transition: all 0.2s ease;
      text-transform: uppercase;
      letter-spacing: 0.5px;
    }

    .login-btn:hover {
      background: var(--brand-purple-dark);
      box-shadow: 0 4px 12px rgba(79, 58, 156, 0.2);
    }

    .footer-note {
      margin-top: 48px;
      font-size: 12px;
      color: #94a3b8;
      text-transform: uppercase;
      letter-spacing: 0.5px;
    }
  `,
	],
})
export class LoginPage {
	constructor(private oauthService: OAuthService) {}

	login() {
		Sentry.addBreadcrumb({ category: "auth", message: "User initiated login flow by clicking Sign In", level: "info" });
		this.oauthService.initLoginFlow();
	}
}
